import get from 'lodash/get';

const { hostname } = window.location;

const clientIdByHostname: Record<string, string> = {
  'auth.myaccount-login.revers.io': 'myaccount.revers.io',
  'auth.ekinsport-login.revers.io': 'ekinsport.revers.io',
  'auth.sav-login.auchan.fr': 'auchan.revers.io',
  'auth.sav-login.magasins-u.com': 'cooperative-u.revers.io',
  'ades.auth.revers.io': 'ades.revers.io',
  'flaudis.auth.revers.io': 'flaudis.revers.io',
  'vitus.auth.revers.io': 'vitus.revers.io',
  'wclean.auth.revers.io': 'wclean.revers.io',
  'sellerstandard.auth.revers.io': 'sellerstandard.revers.io',
  'revers-io.auth.revers.io': 'revers-io.revers.io',
  'ecorepar.auth.revers.io': 'ecorepar.revers.io',
  'ecorepa.auth.revers.io': 'ecorepa.revers.io',
  'emma.auth.revers.io': 'emma.revers.io',
};

const authorityByHostname: Record<string, string> = {
  'auth.auchan-login.revers.io': 'https://auchan-login.revers.io',
  'auth.sav-login.auchan.fr': 'https://sav-login.auchan.fr',
  'auth.sav-login.magasins-u.com': 'https://sav-login.magasins-u.com',
};

const authorityByClientId: Record<string, string> = {
  'myaccount.revers.io': 'https://myaccount-login.revers.io',
  'ekinsport.revers.io': 'https://ekinsport-login.revers.io',
  'revers.io': 'https://myaccount-login.revers.io',
  'retours.carrefour.fr': 'https://retours-login.carrefour.fr',
  'auchan.revers.io': 'https://sav-login.auchan.fr',
  'cooperative-u.revers.io': 'https://sav-login.magasins-u.com',
};

const defaultClientId = 'myaccount.revers.io';

function computeAuthority({ clientId }: { clientId: string }) {
  const defaultAuthority = get(authorityByClientId, clientId);
  const defaultAuthorityFromHostname = get(authorityByHostname, hostname);

  if (hostname !== 'localhost' && defaultAuthorityFromHostname) {
    return defaultAuthorityFromHostname;
  }

  if (defaultAuthority) {
    return defaultAuthority;
  }

  const builtAuthorityFromClientId = clientId.replace(
    '.revers.io',
    '-login.revers.io',
  );

  return builtAuthorityFromClientId.includes('https://')
    ? builtAuthorityFromClientId
    : `https://${builtAuthorityFromClientId}`;
}

function setAuthority(authority?: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { clientId } = this;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  this.authority = authority || computeAuthority({ clientId });

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return this;
}

function computeClientId() {
  if (import.meta.env.VITE_CLIENTID) {
    return import.meta.env.VITE_CLIENTID;
  }

  if (hostname === 'localhost') {
    return defaultClientId;
  }

  if (clientIdByHostname[hostname]) {
    return clientIdByHostname[hostname];
  }

  if (window.location.hostname.includes('.auth.revers.io')) {
    return window.location.hostname.replace(
      '.auth.revers.io',
      '.selfcare.revers.io',
    );
  }

  if (window.location.hostname.includes('-auth')) {
    return window.location.hostname.replace('-auth', '');
  }

  if (window.location.hostname.includes('auth.')) {
    return window.location.hostname.replace('-login', '').replace('auth.', '');
  }

  return window.location.hostname;
}

const clientId = computeClientId();

const AuthConfiguration = {
  clientId,
  authority: computeAuthority({ clientId }),
  scope: 'openid email api',
  setAuthority,
};

export default AuthConfiguration;
